module.exports = __webpack_public_path__ + "static/img/page_3.b5e02339.jpg";